
import { defineComponent } from 'vue';
import * as Actions from '@/store/actions';

import { FormRow } from 'mq-ui-kit/lib/FormRow';
import { Button } from 'mq-ui-kit/lib/Button';
import ToastService from 'mq-ui-kit/lib/toast';

import appointmentService from '@/services/appointment.service';

import ProgressIndicator from '@/components/ProgressIndicator/ProgressIndicator.vue';
import PoweredBy from '@/components/PoweredBy/PoweredBy.vue';
import Calendly from '@/components/Calendly/Calendly.vue';

export default defineComponent({
  name: 'Appointment',

  components: {
    PoweredBy,
    ProgressIndicator,
    FormRow,
    Button,
    Calendly,
  },

  data() {
    return {
      disablePreviousButton: false,
    };
  },

  computed: {
    emailAddress() {
      return this.$store.state?.yourdata?.emailAddress;
    },
  },

  created() {
    if (this.$store.state?.employeeID) {
      this.disablePreviousButton = true;
    }
  },

  methods: {
    goToBackPage() {
      this.$router.go(-1);
    },

    goToAppointmentContactSection() {
      this.$router.push({
        name: 'AppointmentContact',
      });
    },

    onAppointmentSuccess() {
      appointmentService.confirmAppointmentHasBeenBooked(this.emailAddress as string)
        .then(() => {
          this.$store.dispatch(Actions.SET_APPOINTMENT_REGISTERED_FLAG, true);
          this.navigateToSuccess();
        })
        .catch(() => {
          ToastService.errorToast(this, this.$t('appointment.errorConfirmAppointment'));
        });
    },

    navigateToSuccess() {
      this.$router.push({
        name: 'Success',
      });
    },
  },
});
